import {useEffect} from 'react';

import {getEventFamilyNames, isEventFamiliesLoaded} from 'src/modules/event-families/services';
import {getAllEventFamilies} from 'src/openapi/apis/EventFamilyControllerApi';
import {useAppDispatch, useAppSelector} from 'src/store';

export const useEventFamilies = (): string[] => {
    const dispatch = useAppDispatch();
    const isLoaded = useAppSelector(isEventFamiliesLoaded);
    const familyNames = useAppSelector(getEventFamilyNames);

    useEffect(() => {
        if (!isLoaded) {
            dispatch(getAllEventFamilies());
        }
    }, [dispatch, isLoaded]);

    return familyNames;
};
